import { Pagination, Table } from '@mui/material'
import React, { useEffect, useState } from 'react'
import demoData from '../../../demo.json'
import TableBody from '@mui/material/TableBody'
import TableHead from '@mui/material/TableHead'
import { useSelector } from 'react-redux'
import { type RootState } from '../../../store'

const DemoGenericTable = (): JSX.Element => {
  const kpiType = useSelector((state: RootState) => state.kpiType)
  const [data, setData] = useState<any[]>([])
  const [page, setPage] = useState<number>(0)

  console.log('GenericTable', kpiType)

  useEffect(() => {
    demoData.reports
      .filter(r => r.history != null && r.name === kpiType)
      .forEach((report) => {
        loadData(report)
      })
  }, [kpiType])

  useEffect(() => {
    demoData.reports
      .filter(r => r.history != null && r.name === kpiType)
      .forEach((report) => {
        loadData(report)
      })
  }, [page])

  const loadData = (report: any): any => {
    const pages: any[] = []
    let k = 0
    let p = 0

    console.log('loadData', kpiType, report)

    if (report.history == null) {
      return
    }

    let page = []

    for (let i = 0; i < report.history.series[0].data.length; i++) {
      const n = report.history.series[0].data[i]
      const catName = (report.history.categories?.[i] != null) ? report.history.categories[i] : 'n/a'
      for (let j = 0; j < n; j++) {
        page.push({ id: k, name: catName })
        k++

        if (k % 20 === 0) {
          pages[p] = page
          page = []
          p++
        }
      }
    }
    console.log('generated pages', pages)

    setData(pages)

    console.log('generated pages - data', data)
  }

  const styleTable: React.CSSProperties = {
    width: '100%',
    backgroundColor: '#272727',
    border: '1px solid #303030',
    borderRadius: '10px',
    marginBottom: '16px',
    padding: 0,
    marginTop: '20px',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  }

  const styleCell: React.CSSProperties = {
    color: '#d0d0d0',
    textAlign: 'center',
    border: '1px solid #303030',
    borderRadius: '10px',
    marginBottom: '16px',
    padding: '.3em 1em',
    marginTop: '20px',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  }

  console.log('demoData.reports', demoData.reports)

  const padLeft = (number: number, length: number): string => {
    let result = String(number + 1)
    for (let i = result.length; i < length; ++i) {
      result = '0' + result
    }
    return result
  }

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ): any => {
    setPage(value - 1)
  }

  const getPage = (page: number): any => {
    if (data[page] == null) {
      return (<></>)
    }
    const content = data[page]
    const ret: JSX.Element[] = []
    content.forEach((d: any) => {
      console.log(d)
      ret.push(
          <tr key={d.id}>
            <td style={styleCell}>K40220000{padLeft(d.id, 4)}</td>
            <td style={styleCell}>BCD012345{padLeft(d.id, 4)}</td>
            <td style={styleCell}>{d.name}</td>
            <td style={styleCell}>Water-Merlin</td>
            <td style={styleCell}>1.40</td>
            <td style={styleCell}>Active</td>
          </tr>
      )
    })
    return ret
  }

  const renderDemoHistoryTable = (): any => {
    return getPage(page)
  }

  return (
    <>
      <Table style={styleTable}>
        <TableHead>
          <tr>
            <th style={styleCell}>Serial Number</th>
            <th style={styleCell}>ClipOn Serial Number</th>
            <th style={styleCell}>Shipment date</th>
            <th style={styleCell}>Device Type</th>
            <th style={styleCell}>Firmware Version</th>
            <th style={styleCell}>State</th>
          </tr>
        </TableHead>
        <TableBody>
          {renderDemoHistoryTable()}
        </TableBody>
      </Table>
      <div style={{ margin: '10px 0px 20px', display: 'flex', justifyContent: 'center' }}>
        <Pagination
            count={data.length}
            page={page + 1}
            onChange={handlePageChange}
            sx={{ ml: 2, mr: 2 }}
        />
      </div>
    </>
  )
}

export default DemoGenericTable
